// removed by extract-text-webpack-plugin
module.exports = {"colorSwatch--light":"_3QWjhLpHxxlp0JWWdmuGAR","colorSwatch--unavailable":"_1iiVSoyDBfmI7F4ijrpfg8","colorSwatch--dark":"_1E8CGsLcL6MGlqHSbKbkjR","colorSwatch__sample":"_2pnNalkCDOYsLYN2CAY7mD","colorSwatch__label":"_3glrY3k9sjii62xLBfmd5z"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/ColorSwatch/paintersStyle.scss
// module id = 937
// module chunks = 0